<template>
  <div class="good2know page-component">
    <div class="container">
      <h1 class="text-center">{{ title }}</h1>
      <div class="grid-vertical-cards">
        <Good2KnowItem
          v-for="Good2Know in Good2Knows"
          :key="Good2Know.id"
          :title="Good2Know.good2know_title[0].text"
          :text="Good2Know.good2know_text"
          :link="Good2Know.good2know_link"
        ></Good2KnowItem>
      </div>
    </div>
  </div>
</template>

<script>
import Good2KnowItem from './Good2KnowItem.vue'
import EventBus from '../../EventBus'
export default {
  components: { Good2KnowItem },
  name: 'Good2Know',
  props: ['title'],
  data() {
    return {
      documentId: '',
      Good2Knows: null
    }
  },
  methods: {
    async getContent(language) {
      let document = await this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'good2know'), {lang: language}
      )
      if (document) {
        this.Good2Knows = document.results.map(result => result = {
            good2know_title: result.data.good2know_title,
            good2know_text: result.data.good2know_text,
            good2know_link: result.data.good2know_link
          })
      }
    }
  },
  async created() {
    await this.getContent(window.KriensTourismus.language)

    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  }
}
</script>